export const SCREEN_WIDTH = {
  mobileSmall: '468px',
  mobile: '768px',
  mobileMinWidth: '769px',
  tablet: '1024px',
  tabletMinWidth: '1025px',
}